import { dailyActivitySchema, type DailyActivity } from '@cadencia/contracts';
import { logger } from '../../lib/logger.js';
import { db } from '../db.js';
import { parchear } from '../parchear.js';
import { newSyncColumns, putRow, type WriteContext } from '../writes.js';

/**
 * Pasos diarios (§17, migracion 0028).
 *
 * Una fila por dia, como el peso: volver a anotar un dia corrige su numero en
 * vez de sumar otro. El indice unico de la 0028 lo impone tambien en el
 * servidor.
 */

/** Los pasos anotados, de antiguo a moderno, con los dos extremos incluidos. */
export async function listActivity(
  userId: string,
  desde?: string,
  hasta?: string,
): Promise<DailyActivity[]> {
  const filas = await db.dailyActivity.where('userId').equals(userId).toArray();
  const salida: DailyActivity[] = [];
  let invalidas = 0;
  for (const fila of filas) {
    if (fila.deletedAt !== null) continue;
    if (desde !== undefined && fila.activityDate < desde) continue;
    if (hasta !== undefined && fila.activityDate > hasta) continue;
    const resultado = dailyActivitySchema.safeParse(fila);
    if (!resultado.success) invalidas += 1;
    salida.push(resultado.success ? resultado.data : fila);
  }
  if (invalidas > 0) {
    logger.warn('db', 'ACTIVITY_SHAPE_MISMATCH', 'Filas locales que no encajan con su contrato', {
      tabla: 'dailyActivity',
      invalidas,
    });
  }
  return salida.sort((a, b) => a.activityDate.localeCompare(b.activityDate));
}

export interface StepsInput {
  activityDate: string;
  steps: number;
}

/**
 * Anota los pasos de un dia. Siempre `manual`: es la unica fuente que existe.
 *
 * `activeMinutes` no lo pide ninguna pantalla y se conserva si ya estaba.
 */
export async function saveSteps(ctx: WriteContext, input: StepsInput): Promise<DailyActivity> {
  const [previo] = await listActivity(ctx.userId, input.activityDate, input.activityDate);
  const row =
    previo === undefined
      ? dailyActivitySchema.parse({
          ...newSyncColumns(ctx),
          ...input,
          source: 'manual',
          activeMinutes: null,
        })
      : parchear(dailyActivitySchema, previo, input, {
          tabla: 'daily_activity',
          id: previo.id,
        });
  return putRow(ctx, 'dailyActivity', row);
}
